import { createMutationHook, createQueryHook } from "../factory";

export const askAutodorQueueKeys = {
  all: ["askAutodorQueues"] as const,
  lists: () => [...askAutodorQueueKeys.all, "list"] as const,
  list: <T>(filters: T) => [...askAutodorQueueKeys.lists(), filters] as const,
  names: () => [...askAutodorQueueKeys.lists(), "names"],
  details: () => [...askAutodorQueueKeys.all, "detail"] as const,
  detail: ({ id }: { id: string }) =>
    [...askAutodorQueueKeys.details(), id] as const,
};

export const queues = {
  createAskAutodorQueue: createMutationHook({
    methodSelector: (alaffiaClient) =>
      alaffiaClient.queues.createAskAutodorQueue,
    mutationKey: ["askAutodorQueues", "createAskAutodorQueue"],
  }),
  createQueue: createMutationHook({
    methodSelector: (alaffiaClient) => alaffiaClient.queues.createQueue,
    mutationKey: ["queues", "createQueue"],
  }),
  deleteAskAutodorQueue: createMutationHook({
    methodSelector: (alaffiaClient) =>
      alaffiaClient.queues.deleteAskAutodorQueue,
    mutationKey: ["askAutodorQueues", "deleteAskAutodorQueue"],
  }),
  getAskAutodorQueue: createQueryHook({
    methodSelector: (alaffiaClient) => alaffiaClient.queues.getAskAutodorQueue,
    queryKeyFn: askAutodorQueueKeys.detail,
  }),
  getAskAutodorQueues: createQueryHook({
    methodSelector: (alaffiaClient) => alaffiaClient.queues.getAskAutodorQueues,
    queryKeyFn: askAutodorQueueKeys.list,
  }),
  getAskAutodorQueueNames: createQueryHook({
    methodSelector: (alaffiaClient) =>
      alaffiaClient.queues.getAskAutodorQueueNames,
    queryKeyFn: askAutodorQueueKeys.names,
  }),
  saveCasesAsQueue: createMutationHook({
    methodSelector: (alaffiaClient) => alaffiaClient.queues.saveCasesAsQueue,
    mutationKey: ["askAutodorQueues", "saveCasesAsQueue"],
  }),
  updateAskAutodorQueue: createMutationHook({
    methodSelector: (alaffiaClient) =>
      alaffiaClient.queues.updateAskAutodorQueue,
    mutationKey: ["askAutodorQueues", "updateAskAutodorQueue"],
  }),
  updateQueue: createMutationHook({
    methodSelector: (alaffiaClient) => alaffiaClient.queues.updateQueue,
    mutationKey: ["queues", "updateQueue"],
  }),
};
